import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://f8306690fe92b22d842a7b13f07205da@o4511877610930176.ingest.us.sentry.io/4511877831786496',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Se traza el 10% de las transacciones para no consumir la cuota
  tracesSampleRate: 0.1,
  // A quién se le propaga la cabecera de trazado: solo la API, para que una
  // traza del navegador y la del backend queden unidas en el mismo evento.
  tracePropagationTargets: ['localhost', /^https:\/\/api\.dietranscargo\.com\/api/],

  // Session Replay: se graba el 5% de las sesiones y el 100% de las que tengan
  // un error, que son las que sirven para reconstruir qué hizo el usuario.
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,

  environment: environment.production ? 'production' : 'development',
  enabled: environment.production,

  // Los releases son a nivel de organización, así que se prefija con el
  // proyecto para no colisionar con los del backend. Debe coincidir con el
  // release que se cree al desplegar.
  release: 'dietrans-frontend@' + environment.version,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
